




















































import Vue from 'vue'
import DatePicker from './ReportingDatePicker.vue'
import Select from './ReportingSelect.vue'
import YearSelect from './ReportingYearSelect.vue'
import MonthSelect from './ReportingMonthSelect.vue'
import WeekSelect from './ReportingWeekSelect.vue'
import Autocomplete from './ReportingAutocomplete.vue'
import { FilterItems, ReportFilterItem } from '@/types/service-response'
import { GENERATE_REPORT } from '@/store/action-types'
import { GenerateReportPayload } from '@/types/payload'
import moment from 'moment'
import QuestionDialog from '@/components/QuestionDialog.vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import PlanningGroupSelect from '@/components/reporting/ReportingPlanningGroupSelect.vue'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'

interface ComponentData {
  componentTypeMap: Map<number, string>
  filterMap: Map<string, string>
  isValid: boolean
  showSnackbar: boolean
  showSuccessSnackbar: boolean
  filterItem: GenerateReportPayload
  selectedYear: string
  errorMessage: string
  successMessage: string
  showQuestionDialog: boolean
  questionDialogTitle: string
  questionDialogLabel: string
  filteredPlanningGroupList: PlanningGroup[]
  loadingPDF: boolean
  loadingEXCEL: boolean
  loadingWORD: boolean
  loadingMail: boolean
  loadingPrintPDF: boolean
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingFilter',

  components: {
    DatePicker,
    Select,
    YearSelect,
    MonthSelect,
    WeekSelect,
    QuestionDialog,
    PlanningGroupSelect,
    Autocomplete
  },

  props: {
    reportItem: {
      type: Array as () => Array<ReportFilterItem>
    },
    reportLayout: String,
    reportName: String,
    addressId: {
      type: Number,
      default: undefined
    },
    planningGroupList: Array as () => PlanningGroup[]
  },

  data (): ComponentData {
    return {
      componentTypeMap: new Map([
        [0, 'Select'], [1, 'DatePicker'], [3, 'YearSelect'], [4, 'MonthSelect'], [5, 'WeekSelect'], [6, 'PlanningGroupSelect'], [7, 'Autocomplete']
      ]),
      filterMap: new Map([]),
      isValid: false,
      showSnackbar: false,
      showSuccessSnackbar: false,
      filterItem: {
        employee: '',
        employeeLabel: '',
        department: '',
        departmentLabel: '',
        date: '',
        dateLabel: '',
        profitCenter: '',
        profitCenterLabel: '',
        filter: '',
        filterLabel: '',
        year: '',
        yearLabel: '',
        from: '',
        fromLabel: '',
        to: '',
        toLabel: '',
        color: '',
        colorLabel: '',
        month: '',
        monthLabel: '',
        layers: '',
        layersLabel: '',
        absencReason: '',
        absencReasonLabel: '',
        kwDatumVon: '',
        kwDatumVonLabel: '',
        reportLayout: '',
        reportName: '',
        address: '',
        addressLabel: '',
        planningGroup: '',
        planningGroupLabel: '',
        sendEmail: false,
        sendTo: '',
        sendToLabel: '',
        prozessArt: '',
        prozessArtLabel: '',
        format: 'PDF'
      },
      selectedYear: '',
      errorMessage: '',
      successMessage: '',
      showQuestionDialog: false,
      questionDialogTitle: '',
      questionDialogLabel: '',
      filteredPlanningGroupList: [],
      loadingPDF: false,
      loadingEXCEL: false,
      loadingWORD: false,
      loadingMail: false,
      loadingPrintPDF: false
    }
  },

  computed: {
    filter (): Array<ReportFilterItem> | void {
      if (this.reportItem) {
        if(this.addressId) {
          const filteredReportItem = this.reportItem.filter((item: ReportFilterItem) => item.Name === "Adresse")
          if(filteredReportItem[0]) {
            const filteredFilterItem: FilterItems | undefined = filteredReportItem[0].Items.find((item: FilterItems) => item.FilterItemId === this.addressId)

            const addressLabel: string = filteredFilterItem ? filteredFilterItem.FilterItemValue : ''
            const payload: Payload = {
              name: "Adresse",
              value: this.addressId.toString(),
              label: addressLabel
            }
            this.onSelectChange (payload)
          }
          return this.reportItem.filter((item: ReportFilterItem) => item.Name !== "Adresse")
        } else {
          return this.reportItem
        }
      }
    },

    showSendEmailButton (): boolean {
      return securityService.isVisible(SecurityArea.Reports, SecurityComponent.SendEmailIcon)
    },

    isDisabledSendEmailButton (): boolean {
      return securityService.isDisabled(SecurityArea.Reports, SecurityComponent.SendEmailIcon)
    },
  },

  methods: {

    onSelectChange (payload: Payload): void {
      if (payload.name === 'Mitarbeiter') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.employee = payload.value
        this.filterItem.employeeLabel = payload.label
      } else if (payload.name === 'Abteilung') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.department = payload.value
        this.filterItem.departmentLabel = payload.label
        this.filterPlanningGroupList(payload.value)
      } else if (payload.name === 'Filiale') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.profitCenter = payload.value
        this.filterItem.profitCenterLabel = payload.label
      } else if (payload.name === 'Filter') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.filter = payload.value
        this.filterItem.filterLabel = payload.label
      } else if (payload.name === 'Farbe') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.color = payload.value
        this.filterItem.colorLabel = payload.label
      } else if (payload.name === 'Grund') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.absencReason = payload.value
        this.filterItem.absencReasonLabel = payload.label
      } else if (payload.name === 'Schichten') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.layers = payload.value
        this.filterItem.layersLabel = payload.label
      } else if (payload.name === 'Adresse') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.address = payload.value
        this.filterItem.addressLabel = payload.label
      } else if (payload.name === 'Planungsgruppe') {
        if(payload.value) {
          this.filterMap.set(payload.name, payload.value)
        } else {
          this.filterMap.delete(payload.name)
        }
        this.filterItem.planningGroup = payload.value
        this.filterItem.planningGroupLabel = payload.label
      }  else if (payload.name === 'EmailFilter') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.sendTo = payload.value
        this.filterItem.sendToLabel = payload.label
      } else if (payload.name === 'ProzessArt') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.prozessArt = payload.value
        this.filterItem.prozessArtLabel = payload.label
      }
    },

    filterPlanningGroupList (department: string): void {
      this.filteredPlanningGroupList = this.planningGroupList.filter((item: PlanningGroup) => item.department === parseInt(department))
    },

    dateChange (payload: Payload): void {
      if(payload.value.length > 0) {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.date = payload.value
        this.filterItem.dateLabel = payload.label
      } else {
        this.filterMap.delete(payload.name)
        this.filterItem.date = ''
        this.filterItem.dateLabel = ''
      }
    },

    onYearChange (payload: Payload): void {
      this.filterMap.set(payload.name, payload.value)
      this.filterItem.year = payload.value
      this.selectedYear = payload.value
      this.filterItem.yearLabel = payload.label
    },

    onMonthChange (payload: Payload): void {
      this.filterMap.set(payload.name, payload.value)
      this.filterItem.month = payload.value
      this.filterItem.monthLabel = payload.label
    },

    onWeekChange (payload: Payload): void {
      if (payload.name === 'KWdatumVon') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.kwDatumVon = payload.value
        this.filterItem.kwDatumVonLabel = payload.label
      } else if (payload.name === 'Von') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.from = payload.value
        this.filterItem.fromLabel = payload.label
      } else if (payload.name === 'Bis') {
        this.filterMap.set(payload.name, payload.value)
        this.filterItem.to = payload.value
        this.filterItem.toLabel = payload.label
      }
    },

    async onGenerateReportClick (sendEmail: boolean, print: boolean, excel: boolean, word: boolean): Promise<void> {
      this.filterItem.reportLayout = this.reportLayout
      this.filterItem.reportName = this.reportName
      this.filterItem.sendEmail = sendEmail
      this.filterItem.format = excel ? 'Excel' : word ? 'Word' : 'PDF'
      this.isValid = true
      let requiredItems: Array<string> = []
      this.reportItem.forEach((item: ReportFilterItem) => {
        if (item.IsRequired === true)
          requiredItems.push(item.Name)
      })

      let requiredResult = requiredItems.map((item: string) => {
        return this.filterMap.has(item)
      })

      if (this.reportLayout === 'PEPI_PL_KWMA') {
        if (moment(this.filterItem.from, 'DD.MM.YYYY h:mm:ss').isAfter(moment(this.filterItem.to, 'DD.MM.YYYY h:mm:ss'))) {
          requiredResult.push(false)
          this.errorMessage = this.$t('reportingFilter.incorrectlyEnteredValues').toString()
          this.showSnackbar = true
        }
      }

      if (!requiredResult.includes(false)) {
        try {
          if(sendEmail) {
            this.loadingMail = true
          } else {
            if(print) {
              this.loadingPrintPDF = true
            } else {
              if(excel) {
                this.loadingEXCEL = true
              } else if(word) {
                this.loadingWORD = true
              } else {
                this.loadingPDF = true
              }
            }
          }
          const data = await this.$store.dispatch(GENERATE_REPORT, this.filterItem)
          this.loadingMail = false
          this.loadingPDF = false
          this.loadingEXCEL = false
          this.loadingWORD = false
          this.loadingPrintPDF = false
          if(!sendEmail) {
            if(!print) {
              let fileData = new Blob([data.data], { type: data.headers['content-disposition'] })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(fileData)
              let filename = data.headers['content-disposition'].split(';')[1].split('filename')[1].split('=')[1].trim()
              link.download = filename
              link.click()
            } else {
              let pdfData = new Blob([data.data], { type: 'application/pdf' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(pdfData)
              let filename = data.headers['content-disposition'].split(';')[1].split('filename')[1].split('=')[1].trim()
              link.download = filename
              let iframe = document.createElement('iframe')

              iframe.style.display = "none"
              iframe.src = window.URL.createObjectURL(pdfData)

              document.body.appendChild(iframe)
              if(iframe && iframe.contentWindow && iframe.contentWindow) {
                iframe.contentWindow.focus()
                iframe.contentWindow.print()
              }
            }
          } else {
            if(data.data.Result !== 0) {
              this.errorMessage = data.data.Message
              this.showSnackbar = true
            } else {
              this.successMessage = data.data.Message
              this.showSuccessSnackbar = true
            }
          }
        } catch (e) {
          this.loadingMail = false
          this.loadingPDF = false
          this.loadingEXCEL = false
          this.loadingWORD = false
          this.loadingPrintPDF = false
          this.errorMessage = this.$t('reportingFilter.reportCouldNotBeGenerated').toString()
          this.showSnackbar = true
        }
      }
    },

    onShowQuestionDialogClick (): void {
      this.isValid = true
      let requiredItems: Array<string> = []
      this.reportItem.forEach((item: ReportFilterItem) => {
        if (item.IsRequired === true)
          requiredItems.push(item.Name)
      })

      let requiredResult = requiredItems.map((item: string) => {
        return this.filterMap.has(item)
      })

      if (this.reportLayout === 'PEPI_PL_KWMA') {
        if (moment(this.filterItem.from, 'DD.MM.YYYY h:mm:ss').isAfter(moment(this.filterItem.to, 'DD.MM.YYYY h:mm:ss'))) {
          requiredResult.push(false)
          this.errorMessage = this.$t('reportingFilter.incorrectlyEnteredValues').toString()
          this.showSnackbar = true
        }
      }

      if (!requiredResult.includes(false)) {
        this.questionDialogTitle = this.$t('reportingFilter.sendByEmail').toString()
        this.questionDialogLabel = this.$t('reportingFilter.doYouReallyWantToSendEmails').toString()
        this.showQuestionDialog = true
      }
    },

    onQuestionDialogClose (): void {
      this.showQuestionDialog = false
    },

    onQuestionDialogSave (): void {
      this.showQuestionDialog = false
      this.onGenerateReportClick(true, false, false, false)
    },

    onPrintClick (): void {
      this.onGenerateReportClick(false, true, false, false)
    },
  }

})
